<script>
    import {incrementItemInCart, decrementItemInCart} from "./cart-store.js";
    import Image from "../components/Image.svelte";

    export let item;
    export let publishConfig;
    export let tenantKey;
</script>

<style>
    .item-container {
        display: flex;
        gap: 1rem;
    }
    .image-block {
        background: #eee;
        width: 4rem;
        height: 4rem;
        min-width: 4rem;
        min-height: 4rem;
        border-radius: 1rem;
        box-shadow: 0 6px 9px 4px rgb(0 0 0 / 8%);
    }
    .info-block {
        flex: 1 1;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    p {
        margin: 0 0 .5rem 0;
        color: #555;
        font-size: .85rem;
    }
    .count {
        display: flex;
        align-items: center;
        gap: .5rem;
    }
    button {
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        background: transparent;
        font-size: 1.25rem;
        padding: 0;
        color: var(--secondary-font-color);
    }
</style>


<div class="item-container">
    <div class="image-block">
        <Image src={item.img} tenantKey={tenantKey} fillContainer={true}></Image>
    </div>
    <div class="info-block">
        <strong>{ item.name }</strong>
        {#if (item.weight !== undefined)}
        <p>{ item.weight }</p>
        {/if}

        <div style="display: flex; justify-content: space-between; align-items: center;">
            <div>{publishConfig?.currency ? publishConfig.currency : ''}{ item.price }</div>

            <div class="count">
                <button on:click={() => decrementItemInCart(item, item.price, item.priceIndex, item.modificators)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CircleMinus"><path d="M16 12H8"/><circle cx="12" cy="12" r="10"/></svg>
                </button>
                <span>{ item.count }</span>
                <button on:click={() => incrementItemInCart(item, item.price, item.priceIndex, item.modificators)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
                </button>
            </div>
        </div>
    </div>
</div>
